



















































import Vue from 'vue';
import {
  mapGetters,
  mapActions,
} from 'vuex';

interface IData {
  query: string;
}

interface IMethods {
  toggleNavBar: () => void;
  search: (payload: Record<string, string | number>) => void;
  goHome: () => void;
  loginPage: () => void;
  makeSearch: () => void;
}

interface IComputed {
  isLoggedIn: boolean;
  landingPage: boolean;
}

interface IProps {
}

export default Vue.extend<IData, IMethods, IComputed, IProps>({
  name: 'AppBar',

  data: () => ({
    query: '',
  }),

  computed: {
    ...mapGetters('user', [
      'isLoggedIn',
    ]),

    landingPage() {
      return this.$route.name === 'Landing';
    },
  },

  methods: {
    ...mapActions('user', [
      'toggleNavBar',
    ]),

    ...mapActions('navigation', [
      'search',
    ]),

    goHome() {
      if (this.isLoggedIn) {
        this.$router.push('/home');
      } else {
        this.$router.push('/');
      }
    },

    loginPage() {
      this.$router.push('/login');
    },

    makeSearch() {
      this.search({
        query: this.query,
      });
    },
  },
});
